export default {"src":"/_next/static/media/polygon-explorer.c597b03d.svg","height":417,"width":471,"blurWidth":0,"blurHeight":0};